module.exports = __webpack_public_path__ + "Breymont-Bold.c3e5cb69be126fc40510.eot";


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/assets/scss/fonts/Breymont-Bold.eot
// module id = ../../../../../src/assets/scss/fonts/Breymont-Bold.eot
// module chunks = styles